import React from 'react';
import ContactForm from "./ContactForm";
import {updateAnalytics} from "./utils";

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hours: [],
            phone: '',
            addressOne: '',
            addressTwo: ''
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            contactDetails: nextProps.contactDetails
        }, function () {
            this.loadData();
        })
    }

    loadData() {
        this.setState({
            addressOne: this.state.contactDetails && this.state.contactDetails.address_one,
            addressTwo: this.state.contactDetails && this.state.contactDetails.address_two,
            phone: this.state.contactDetails && this.state.contactDetails.phone,
            hours: this.state.contactDetails && this.state.contactDetails.hours,
            showBusinessHours: this.state.contactDetails && this.state.contactDetails.show_business_hours,
            show_contact_us_form: this.state.contactDetails && this.state.contactDetails.show_contact_us_form,
            contact_email_enabled: this.state.contactDetails && this.state.contactDetails.contact_email_enabled,
            contact_number_enabled: this.state.contactDetails && this.state.contactDetails.contact_number_enabled,
            longitude: this.state.contactDetails && this.state.contactDetails.longitude,
            latitude: this.state.contactDetails && this.state.contactDetails.latitude,
            businessName: this.state.contactDetails && this.state.contactDetails.businessName,
            showContactAddress: this.state.contactDetails && this.state.contactDetails.show_contact_address,
            showServiceArea: this.state.contactDetails && this.state.contactDetails.show_service_area,
            serviceArea: this.state.contactDetails && this.state.contactDetails.service_area && this.state.contactDetails.service_area.split('\n').map(i => {
                return <>{i}<br/></>
            }),
            contactUsImage: this.state.contactDetails && this.state.contactDetails.contact_us_image
        });
    }


    gmapsAddress = () => {
        let gmapBase = "https://www.google.com/maps/search/?api=1&&query="
        let buildQuery = this.state.businessName + "," + this.state.addressOne + "," + this.state.addressTwo
        return gmapBase + buildQuery;
    }

    componentWillMount() {
        this.setState({
            contactDetails: this.props.contactDetails
        }, function () {
            this.loadData();
        })
    }

    displayHours(timings) {
        if (timings.status == "OPEN") {
            return <span className="contact-details__text--time"> {this.displayTiming(timings.timing)} </span>;
        } else {
            return <span className="contact-details__text--time">CLOSED</span>;
        }
    }

    displayTiming = (timing) => {
        let startingHour = timing.split("-")[0].split(":")[0].trim().replace(/^0+/, '');
        let startingMinute = timing.split("-")[0].split(":")[1].split(" ")[0] === "00" ? '' : timing.split("-")[0].split(":")[1].split(" ")[0];
        let startingSession = timing.split("-")[0].split(":")[1].split(" ")[1]
        let endingHour = timing.split("-")[1].split(":")[0].trim().replace(/^0+/, '');
        let endingMinute = timing.split("-")[1].split(":")[1].split(" ")[0] === "00" ? '' : timing.split("-")[1].split(":")[1].split(" ")[0];
        let endingSession = timing.split("-")[1].split(":")[1].split(" ")[1];
        let time = startingHour + (startingMinute ? ':' : '') + startingMinute + ' ' + startingSession + ' - ' + endingHour + (endingMinute ? ':' : '') + endingMinute + ' ' + endingSession;
        return time
    }

    displayWorkingHours = () => {
        if (this.state.showBusinessHours)
            return (
                <div className="contact-details working-hours">
                    <span className="contact-details__title">Hours</span>
                    {this.state.hours.map((day, index) => (
                        <p className="contact-details__text">
                            <span className="contact-details__text--week">{this.displayWeekDay(day.day)}</span>
                            {this.displayHours(day)}
                        </p>
                    ))}
                </div>
            )
    }

    displayWeekDay = (day) => {
        if (day === 'THURSDAY')
            return day.substring(0, 2);
        else
            return day.substring(0, 1);
    }


    displayContactAddress() {
        if (this.state.showContactAddress)
            return (
                <>
                    <span className="contact-details__title">ADDRESS</span>
                    <div className="addressHolder" style={{display: 'flex'}}>
                        <a target="_blank" className="mapIcon" href={this.gmapsAddress()}
                           onClick={(e) => {
                               updateAnalytics('map_access', [], this.props.PCBID)
                           }}>
                            <p className="contact-details__text">
                                {this.state.addressOne}
                                <br></br>
                                {this.state.addressTwo}
                            </p>

                            <i class="fa fa-map-marker-alt" aria-hidden="true"/>
                        </a>
                    </div>
                </>
            )
    }

    displayServiceArea() {
        let spanClass = this.state.showContactAddress ? "contact-details__title pt-40" : 'contact-details__title'
        if (this.state.showServiceArea)
            return (
                <>
                    <span className={spanClass}>SERVICE AREA</span>
                    <div className="addressHolder" style={{display: 'flex'}}>
                        <p className="contact-details__text contact-details__serviceArea">
                            {this.state.serviceArea}
                        </p>
                    </div>
                </>
            )
    }

    locationListButton = () => {
        if (this.props.locationListStatus) {
            return (
                <div className="contact-details" style={{margin: "20px 0"}}>
                    <a onClick={i => this.props.showLocationModal()} className="btn btn-center btn-primary"
                       style={{marginRight: '15px'}}>
                        {this.props.locationDisplayName}
                    </a>
                </div>
            )
        }
    }


    render() {
        let styleVal = this.state.showBusinessHours ? 'center' : 'unset'
        return (
            <section>

                <section className="wrap-top" id="contact">

                    <span className='contact-bg'><img alt={document.title} src={this.state.contactUsImage}/></span>
                    <div className="content">

                        <div className="two-column">
                            <div className="right-column" id="goto-contact-header">

                            </div>
                            <div className="left-column" style={{justifyContent: styleVal}}>
                                <h2 className="title title__bordered-left" id="contactHeader"><span>Contact Us</span>
                                </h2>
                                <div className='contact-details-left'>
                                    <div className="contact-details">

                                        {this.displayContactAddress()}

                                        {this.displayServiceArea()}

                                        {this.locationListButton()}

                                        <span className="contact-details__title pt-40">PHONE</span>
                                        <p className="contact-details__text">
                                            <a className="contact-details__text"
                                               href={'tel:' + this.state.phone}>{this.state.phone}</a>
                                        </p>
                                    </div>
                                    {this.displayWorkingHours()}
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="wrap-top" id="get-connected">
                    <div className="content">
                        <h2 className='title'>{this.state.show_contact_us_form ? 'GET CONNECTED' : ''}</h2>
                        <ContactForm
                            onClick={(i) => this.props.onClick(i)}
                            PCBID={this.props.PCBID}
                            contactFormStatus={this.state.show_contact_us_form}
                            contactEmailStatus={this.state.contact_email_enabled}
                            contactNumberStatus={this.state.contact_number_enabled}
                        />
                    </div>
                </section>

            </section>

        );
    }
}

export default Contact;